'use client'

import { FC } from 'react'

export interface SPCTASectionProps {
  onCTAClick: () => void
  ctaLabel?: string | null
}

const SPCTASection: FC<SPCTASectionProps> = ({ onCTAClick, ctaLabel }) => {
  return (
    <>
      <div className="info-bottom-fade" />
      <div className="sp-detail-cta-container">
        <button type="button" className="sp-detail-cta-button" onClick={onCTAClick}>
          {ctaLabel || '採用情報へ'}
        </button>
      </div>
    </>
  )
}

export default SPCTASection
